import React from 'react';
import TitleText from '../components/atoms/TitleText';
import InfoText from '../components/atoms/InfoText';

const EditSellerProfile: React.FC = () => {
  return (
    <div className="bg-white dark:bg-dark-surface p-6 rounded-xl shadow-sm" data-testid="edit-seller-profile-page">
      <TitleText text="Edit Seller Profile" className="text-[24px] font-bold mb-2" />
      <InfoText text="This is a placeholder for the Edit Seller Profile page." className="text-[16px] text-gray-500" />
    </div>
  );
};

export default EditSellerProfile;
